import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TrackByFunction } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { PreLoaderModule } from '@ui/feedback/pre-loader/pre-loader.module';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import { NoMatchesComponent } from '@ui/feedback/no-matches/no-matches.component';
import { PaginatorComponent } from '@ui/table/paginator/paginator.component';
import { AbstractGridComponent } from '@ui/base/abstract-grid/abstract-grid.component';
import { B2bProgramType } from '../../../shared/models/b2b-program-type';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';
import { RowLinkDirective } from '@ui/a11y/row-link/row-link.directive';


/**
 * B2B programs list table
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-table-b2b-programs',
    templateUrl: './table-b2b-programs.component.html',
    styleUrls: ['./table-b2b-programs.component.scss'],
    imports: [
        RowLinkDirective,
        MatTableModule,
        MatSortModule,
        PreLoaderModule,
        NoMatchesComponent,
        PaginatorComponent,
        IconBsComponent,
        TranslatePipe,
    ],
})
export class TableB2bProgramsComponent extends AbstractGridComponent<PartnerProgram> implements OnChanges {
    @Input()
    public displayedColumns: string[] = ['number', 'prgName', 'orgName', 'prgType', 'trfName', 'icons'];

    @Input()
    public b2bProgram: PartnerProgram[];

    @Output()
    public clickRow: EventEmitter<number> = new EventEmitter<number>();

    /**
     * Delete event
     *
     * @returns Program object
     */
    @Output()
    public removeClick: EventEmitter<PartnerProgram> = new EventEmitter<PartnerProgram>();

    public readonly b2bProgramType: typeof B2bProgramType = B2bProgramType;
    public readonly identity: TrackByFunction<PartnerProgram> = (index: number, item: PartnerProgram) => item.prgId;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.b2bProgram?.currentValue) {
            this.displayEntities.data = changes.b2bProgram.currentValue;
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
